module.exports = __webpack_public_path__ + "img/kitchen-terrazzo.7563e781.webp";